import { FC } from "react";
import { BalanceState } from "./balance.script";

export const Balance: FC<BalanceState> = () => {
  return null;
};
